<template>
    <DModal
        :title="__('settings.lov_billing_cycles.name')"
        @close="emit('closeModal')"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('settings.lov_billing_cycles.table.billing_cycle')"
                :error="errors.billing_cycle"
                is-required
                :hint="__('settings.lov_billing_cycles.table.billing_cycle_hint')"
            >
                <DInput
                    id="lov_billing_cycles_billing_cycle"
                    v-model="form.billing_cycle"
                    :disabled="isCreate === false"
                    :placeholder="__('settings.lov_billing_cycles.table.billing_cycle')"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.lov_billing_cycles.table.name_de')"
                :error="errors.name_de"
                is-required
                :hint="__('settings.lov_billing_cycles.table.name_de_hint')"
            >
                <DInput
                    id="lov_billing_cycles_name_de"
                    v-model="form.name_de"
                    :placeholder="__('settings.lov_billing_cycles.table.name_de')"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.lov_billing_cycles.table.name_en')"
                :error="errors.name_en"
                is-required
                :hint="__('settings.lov_billing_cycles.table.name_en_hint')"
            >
                <DInput
                    id="lov_billing_cycles_name_en"
                    v-model="form.name_en"
                    :placeholder="__('settings.lov_billing_cycles.table.name_en')"
                />
            </DFormRow>
            <DFormRow
                label=""
            >
                <DButton
                    :label="__('messages.confirm')"
                    color="primary"
                    @click="submitForm"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    billingCycle: {
        type: Object,
        default: () => { return {} }
    },
    isCreate: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['closeModal'])

const form = useForm({
    billing_cycle: props.billingCycle?.billing_cycle ?? null,
    name_de: props.billingCycle?.name_de ?? null,
    name_en: props.billingCycle?.name_en ?? null
})

const errors = ref({})

function submitForm () {
    if (props.isCreate) {
        form.post(route('settings.billing-cycles.store'), {
            onSuccess: () => {
                emit('closeModal')
            },
            onError: (error) => {
                errors.value = error
            }
        })
    } else {
        form.patch(route('settings.billing-cycles.update', { billing_cycle: props.billingCycle?.billing_cycle }), {
            onSuccess: () => {
                emit('closeModal')
            },
            onError: (error) => {
                errors.value = error
            }
        })
    }
}
</script>
